import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-detail-knowledge',
  templateUrl: './detail-knowledge.component.html',
  styleUrls: ['./detail-knowledge.component.scss']
})
export class DetailKnowledgeComponent implements OnInit {

  constructor() { }

  public isFindCourse: boolean = false;
  public isCategories: boolean = false;
  public isUpcomingCourses: boolean = false;
  article;

  ngOnInit(): void {
    this.article = localStorage.getItem('articleselect');
  }

}
